module.exports = __webpack_public_path__ + "static/img/w-4.6188dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-4.jpg
// module id = LMk3
// module chunks = 1